import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getOrderedElements } from '@/previs/screenplayHelpers.ts';
import type { ScreenplayData } from '@/types/timeline.ts';
import type { ScreenplayElement } from '@/previs/screenplayHelpers.ts';
import styles from './ScriptPanel.module.css';

export function StructuredScreenplay({ screenplay }: { screenplay: ScreenplayData }) {
  const elements = useMemo(() => getOrderedElements(screenplay), [screenplay]);

  return (
    <div className={styles.scriptText}>
      {elements.map((el, i) => (
        <ScreenplayElementView key={i} element={el} />
      ))}
    </div>
  );
}

export function ScreenplayElementView({ element }: { element: ScreenplayElement }) {
  const { t } = useTranslation('script');
  switch (element.type) {
    case 'dialogue': {
      const d = element.data;
      const rawName = d.characterName || t('unassignedCharacterName');
      const nameDisplay = d.extension
        ? `${rawName} (${d.extension})`
        : rawName;
      return (
        <div className={styles.dialogueBlock}>
          <div className={styles.characterName}>{nameDisplay}</div>
          {d.parenthetical && (
            <div className={styles.parenthetical}>{d.parenthetical}</div>
          )}
          <div className={styles.dialogueText}>{d.dialogueText}</div>
        </div>
      );
    }
    case 'action':
      return (
        <div className={styles.actionText}>{element.data.actionText}</div>
      );
    case 'transition':
      return (
        <div className={styles.transitionText}>{element.data.transitionText}</div>
      );
  }
}
